import { FeatureConfig } from "./feature-config";

export class ApiConfig {
    module?: string;
    baseUrl?: string;
    features?: FeatureConfig[];

    constructor(config: any) {

        this.module = config?.module;
        this.baseUrl = config?.baseUrl;
        this.features = config?.features == null ? [] : config?.features;
    }

    featureUrl(featureName: string): string | undefined {
        const feature = this.features!.find(item => item.name === featureName);
        if (feature != null) {
            return this.baseUrl! + feature.path;
        }

        return undefined;
    }

}
